import FileSaver from 'file-saver'
import { FileDocument } from '../../../../displaySet/model/AttributeValue'
import { Label } from '../../../../genericComponents/typographie/Label'
import {Link as ButtonLink} from '@mui/material'

export const FieldSummary = ({label, value}: {
    label: string,
    value?: string
}) => {
    return (
        <>
            <Label className="form-summary-label">{label}</Label>
            <span className="form-summary-value">{value ?? '-'}</span>
        </>
    )
}

const StringDisplay = ({value}: { value: string | undefined }) => <span
    className="form-summary-value">{value ?? '-'}</span>


 const FileDisplay = ({value}: { value: FileDocument }) => {
    const getFile = () => {
        const file = value.localFile
        if (!file) return
        FileSaver.saveAs(file, file.name)
    }
    if (value.file) {
        return <div className="form-summary-value-file">
            <span className="form-summary-value">File</span>
            <ButtonLink className="form-summary-value link" onClick={getFile}>
                {value.file.name ?? '-'}
            </ButtonLink>
        </div>
    }
    if (value.externalUrl) {
        return <div className="form-summary-value-file">
            <span className="form-summary-value">URL</span>
            <ButtonLink className="form-summary-value link" href={value.externalUrl}
                        target="_blank">
                {value.externalUrl}
            </ButtonLink>
        </div>
    }
    return <StringDisplay value={undefined}/>
}


export const ProofSummary = ({label, values}: {
    label: string,
    values: FileDocument[]
}) => {
    const allProofs = [
        ...values.filter(p => p.isFile),
        ...values.filter(p => !p.isFile)
    ]
    return (
        <>
            <Label className="form-summary-label">{label}</Label>
            <div className="form-summary-values">
                {allProofs.length > 0 ? allProofs.map((fileDoc, index) => <>
                    <div className="form-summary-values"><FileDisplay key={index} value={fileDoc}/></div>
                </>) : <div className="form-summary-values">-</div>}
            </div>
        </>
    )
}